import RestApiModel from "@/api/Model/RestApiModel";

class LIORiskCode extends RestApiModel {
  static getResourceEndpoint() {
    return '/product-lio-risk-codes-ipr';
  }
}

export default LIORiskCode;
